module.exports = __webpack_public_path__ + "img/curva_duracion_hover.7a775615.png";